import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BibliographicResourceModule } from '®shared/bibliographic-resource';
import { OnlineResourcesModule } from '®shared/list-item';

import {
  BookstoreAvailabilityComponent,
  BookstoreAvailabilityModule,
} from './bookstore';
import { CombinedAvailabilityComponent } from './combined-availability.component';
import {
  LibraryAvailabilityComponent,
  LibraryAvailabilityModule,
} from './library';
import { ResourceAvailabilityComponent } from './resource-availability.component';

@NgModule({
  declarations: [CombinedAvailabilityComponent, ResourceAvailabilityComponent],
  imports: [
    CommonModule,
    BibliographicResourceModule,
    BookstoreAvailabilityModule,
    LibraryAvailabilityModule,
    OnlineResourcesModule,
  ],
  exports: [
    BookstoreAvailabilityComponent,
    CombinedAvailabilityComponent,
    ResourceAvailabilityComponent,
    LibraryAvailabilityComponent,
  ],
})
export class AvailabilityModule {}
